import { useCallback, useEffect, useState } from 'react'

export const useScheduleCalendarReady = (resetKey: string | null | undefined) => {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    setIsReady(false)
  }, [resetKey])

  const markReady = useCallback(() => {
    setIsReady(true)
  }, [])

  return { isReady, markReady }
}
